import React, { useEffect, useState } from 'react';
import api from '../../apis/EdisonApi';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faBatteryEmpty,
	faBatteryQuarter,
	faBatteryHalf,
	faBatteryThreeQuarters,
	faBatteryFull,
    faChevronUp,
    faPlug,
    faClose
} from "@fortawesome/free-solid-svg-icons";
import { faSun } from '@fortawesome/free-regular-svg-icons';

const Aton = () => {
    const [status, setStatus] = useState('NA');

    useEffect(() => {
        const controller = new AbortController();

        getAtonStatus();
        return () => {
            controller.abort();
        };
    }, [])
    
    const getAtonStatus = async () => {
        const resp = await api.get('/aton/status');
        //console.log("Aton status response: ", resp.data);
        setStatus(resp.data);
    };

    const renderPowerProduction = () => {
        if (status === 'NA' || status.powerPV < 0) {
            return <div className="count">NA</div>;
        } else {
            return <div className="count">{status.rawdata.pSolare} W</div> ;
        }      
    };

    const renderPowerConsumption = () => {
        if (status === 'NA' || status.powerConsumed < 0) {
            return <div className="count">NA</div>;
        } else {
            return <div className="count">{status.rawdata.pUtenze} W</div>;
        }
    };

    const renderBatteryIcon = () => {
        if (status === 'NA') {
            return <div className="icon"><FontAwesomeIcon icon={faBatteryEmpty} size="3x" /></div>;
        } else if (status.rawdata.soc > 75) {
            return <div className="icon"><FontAwesomeIcon icon={faBatteryFull} size="3x" /></div>;
        } else if (status.rawdata.soc > 50) {
            return <div className="icon"><FontAwesomeIcon icon={faBatteryThreeQuarters} size="3x" /></div>;
        } else if (status.rawdata.soc > 25) {
            return <div className="icon"><FontAwesomeIcon icon={faBatteryHalf} size="3x" /></div>;
        } else if (status.rawdata.soc > 0) {
            return <div className="icon"><FontAwesomeIcon icon={faBatteryQuarter} size="3x" /></div>;
        } else {
            return <div className="icon"><FontAwesomeIcon icon={faBatteryEmpty} size="3x" /></div>;
        }
    };

    const renderBatteryDischarge = () => {
        if (status === 'NA' || status.rawdata.soc < 0) {
            return <div className="count">NA</div>;
        } else {
            return <div className="count">{status.rawdata.soc}%</div>;
        }
    };

    const renderUserData = () => {                    
        const userData = status?.userData;

        if (!userData)  {
            return (
                <div className="x_content">
                    <div>Device ID: aton1</div>
                    <div>Surname: NA</div>
                    <div>Name: NA</div>
                    <div>Address: NA</div>
                    <div>Cap: NA</div>
                    <div>Province: NA</div>
                    <div>Municipality: NA</div>
                    <div>Latitude: NA</div>
                    <div>Longitude: NA</div>
                    <div>Activation date: NA</div>
                    <div>kWp modules (Power of photovoltaic modules): NA</div>
                    <div>Serial Number: NA</div>
                    <div>Inverter model: NA</div>
                    <div>Photovoltaic module model: NA</div>
                    <div>Battery model: NA</div>
                    <div>Accumulation model: NA</div>
                    <div>Storage battery capacity: NA</div>
                    <div>Last Request (lastRequest): NA</div>
                </div>
            );
        } else {
            let lastDate = new Date(status.timestamp);

            return (
                <div className="x_content">
                    <div>Device ID: aton1</div>
                    <div>Surname: {userData.cognome}</div>
                    <div>Name: {userData.nome}</div>
                    <div>Address: {userData.via}</div>
                    <div>Cap: {userData.cap}</div>
                    <div>Province: {userData.provincia}</div>
                    <div>Municipality: {userData.comune}</div>
                    <div>Latitude: {userData.lat}</div>
                    <div>Longitude: {userData.lon}</div>
                    <div>Activation date: {userData.data_attivazione}</div>
                    <div>Power of photovoltaic modules: {userData.kWp_moduli} kW</div>
                    <div>Serial Number: {userData.matricola}</div>
                    <div>Inverter model: {userData.inverter_codice}</div>
                    <div>Photovoltaic module model: {userData.modello_modulo}</div>
                    <div>Battery model: {userData.codice_batteria}</div>
                    <div>Accumulation model: {userData.tipoDispositivo}</div>
                    <div>Storage battery capacity: {userData.capacita} kWh</div>
                    <div>Last Request: {lastDate.toLocaleString()}</div>
                </div>
            );
        }                                                   
    };

    return (
        <div className="right_col" role="main">
            <header className="page-heading device-page-heading">
                <div>
                    <p className="eyebrow">CONNECTED DEVICE</p>
                    <h1>Aton</h1>
                </div>
            </header>

            <div className="page-title">
                <div className="row top_tiles">
                    <div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <div className="tile-stats">
                            <h3>Power production</h3>
                            <div className="icon"><FontAwesomeIcon icon={faSun} size="3x" /></div>
                            {renderPowerProduction()}         
                        </div>
                    </div>
                    <div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <div className="tile-stats">
                            <h3>Power consumption</h3>
                            <div className="icon"><FontAwesomeIcon icon={faPlug} size="3x" /></div>
                            {renderPowerConsumption()}
                        </div>
                    </div>            
                    <div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
                        <div className="tile-stats">
                            <h3>Battery</h3>       
                            {renderBatteryIcon()}
                            {renderBatteryDischarge()}
                        </div>
                    </div>
                </div>
            </div>

            <div className="clearfix"></div>

            <div className="row">
                <div className="col-xs-12">
                    <div className="x_panel">
                        <div className="x_title">
                            <h2>User Data</h2>
                            <ul className="nav navbar-right panel_toolbox">
                                <li><span id="collapse-link-details" className="collapse-link"><FontAwesomeIcon icon={faChevronUp} size="lg" /></span>
                                </li>
                                <li><span className="close-link"><FontAwesomeIcon icon={faClose} size="lg" /></span>
                                </li>
                            </ul>
                            <div className="clearfix"></div>
                        </div>

                        { renderUserData() }

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Aton;
